export const getNextTaskTitle = (language, existingChatCount = 0) => {
  if (existingChatCount <= 0) {
    return language === 'fa' ? 'پیش‌فرض' : 'Default';
  }

  const number = existingChatCount;
  return language === 'fa' ? `تسک ${number}` : `Task ${number}`;
};
